import React, { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import Verificacion from '../../../components/Verificacion';
import Suspendido from '../../../components/Suspendido';
import Loader from '../../../components/Loader';
import DashboardUsuario from './DashboardUsuario';
import DashboardTecnico from './DashboardTecnico';
import DashboardAdmin from './DashboardAdmin';
import './dashboard.css';

/**
 * Punto de entrada de /dashboard: valida el estado de la cuenta, decide
 * el layout y delega el contenido en uno de los 3 dashboards por rol.
 * La navegación/perfil/logout viven ahora en la sidebar global (components/Sidebar.jsx).
 */
const Dashboard = () => {
  const [minimoTiempoCumplido, setMinimoTiempoCumplido] = useState(false);
  const token = localStorage.getItem('AuthToken');
  const tokenInfo = token ? jwtDecode(token) : {};

  const handleLinkClick = () => window.scrollTo({ top: 0 });

  // Loader mínimo de 1s para evitar parpadeos en conexiones rápidas
  useEffect(() => {
    const t = setTimeout(() => setMinimoTiempoCumplido(true), 1000);
    return () => clearTimeout(t);
  }, []);

  if (!minimoTiempoCumplido) {
    return (
      <div className="loader-fullscreen">
        <Loader />
      </div>
    );
  }

  if (tokenInfo.estado === 'verificar') return <Verificacion />;
  if (tokenInfo.estado === 'suspendido') return <Suspendido />;

  const renderPanel = () => {
    if (tokenInfo.role === 'admin') return <DashboardAdmin tokenInfo={tokenInfo} onLinkClick={handleLinkClick} />;
    if (tokenInfo.role === 'tecnico') return <DashboardTecnico tokenInfo={tokenInfo} onLinkClick={handleLinkClick} />;
    return <DashboardUsuario tokenInfo={tokenInfo} onLinkClick={handleLinkClick} />;
  };

  return (
    <main className="site-width dash-content">
      {renderPanel()}
    </main>
  );
};

export default Dashboard;
